const readErrorCode = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? value : parsed;
};

/**
 * Axios, proxy, and wrapped application errors can carry the Threads error
 * payload at different depths. Keep the parsing in one place so callers do
 * not treat every HTTP 400 as an authentication failure.
 */
export const getThreadsAuthError = (error) => {
  let current = error;
  const visited = new Set();

  while (current && !visited.has(current)) {
    visited.add(current);

    if (current.code === "REAUTH_REQUIRED") {
      return {
        code: 190,
        type: "OAuthException",
        message: current.message,
        reauthRequired: true,
      };
    }

    const responseData = current.response?.data || current.responseData;
    const candidates = [
      responseData?.errorData?.error,
      responseData?.error,
      current.errorData?.error,
      current.error,
    ];

    for (const candidate of candidates) {
      if (!candidate || typeof candidate !== "object") continue;
      const code = readErrorCode(candidate.code);
      if (code === 190 || candidate.type === "OAuthException") {
        return {
          code,
          subcode: readErrorCode(candidate.error_subcode),
          type: candidate.type,
          message: candidate.message || responseData?.error || current.message,
          reauthRequired: code === 190,
        };
      }
    }

    current = current.cause;
  }

  return null;
};

export const isThreadsAuthError = (error) => {
  const authError = getThreadsAuthError(error);
  return authError?.code === 190;
};

export const isReauthenticationRequired = (error) =>
  error?.code === "REAUTH_REQUIRED" || isThreadsAuthError(error);

export const createReauthenticationRequiredError = (cause) => {
  const error = new Error("Threads account reconnection is required");
  error.name = "ReauthenticationRequiredError";
  error.code = "REAUTH_REQUIRED";
  error.cause = cause;
  return error;
};

